
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Jumbotron, Panel, Thumbnail, PageHeader, Button, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import imgHeader_01 from '../../../assets/img/simulator/ColumnCellFlotation_1.jpg';
import imgHeader_02 from '../../../assets/img/simulator/BallMill_1.jpg';

import imgHeader_03 from '../../../assets/img/simulator/ColumnCellFlotation_5.jpg';
import imgHeader_04 from '../../../assets/img/simulator/ColumnCellFlotation_7.jpg';
import imgHeader_05 from '../../../assets/img/simulator/ColumnCellFlotation_3.jpg';
import imgHeader_06 from '../../../assets/img/simulator/ColumnCellFlotation_4.jpg';

import zip_01 from '../../../assets/zip/simulator/TracyBrown_ColumnCell_Simulator.zip';
import zip_02 from '../../../assets/zip/simulator/TracyBrown_BallMill_Simulator.zip';

let fontSize = {fontSize: '1.10em'};

/**
 * Note: Your components tell React what you want to render
 */
class Simulators extends React.Component {
	render() {
		return (
			<div id="ITBuildOut">
				<Jumbotron>
	          <div>
	          	<Grid>
				    		<Row>
				    			<Col xs={12} md={12}>
				    				<center>
					    				<Panel>
					    					<span><center><PageHeader>Software Engineering<br/><small>C# Production Engineering Simulators</small></PageHeader></center></span>

					    					<p className="lead text-justify">With permission from Performance Associates International (<a href="http://www.perfnet.com">PAI</a>), I've posted an example of my <a href="https://en.wikipedia.org/wiki/C_Sharp_(programming_language)">C#</a> production software engineering work. The engineering simulator projects shown here involved the application of applied mathematics for estimating froth flotation levels and mill feed rate. These simulators were written as classic Microsoft <a href="https://en.wikipedia.org/wiki/Windows_Forms">WinForms</a> <a href="https://en.wikipedia.org/wiki/C_Sharp_(programming_language)">C#</a> applications using the <a href="https://en.wikipedia.org/wiki/Graphics_Device_Interface">GDI+</a> graphics framework for drawing and shading images.  All graphics are programmatically expressed through the <a href="https://en.wikipedia.org/wiki/C_Sharp_(programming_language)">C#</a> programming language. I had developed a graphics library built around <a href="https://en.wikipedia.org/wiki/Graphics_Device_Interface">GDI+</a> and a bounded <a href="https://en.wikipedia.org/wiki/Euclidean_geometry">Euclidean geometry</a> to support the rapid creation of graphics to support simulator projects. The objective for these simulators are to train plant <a href="https://en.wikipedia.org/wiki/Control_room">control room</a> operators.</p>
					    				</Panel>
				    				</center>
				    			</Col>
				    		</Row>

				    		<Row>
				    			<Col xs={12} md={6}>
				    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_01}>
				    				<h3>Applied Mathematics</h3>
						         <p className="text-justify" style={fontSize}>Simulating the dynamic behavior of real-world plant equipment is a challenge. The Column-Cell floatation simulator provides an example of applied mathematics as it simulates froth formation, floatation, and overflow (<a href="https://en.wikipedia.org/wiki/Tailings">tailings</a>). The <a href="https://en.wikipedia.org/wiki/PID_controller">PID control</a> scheme is named after its three correcting terms, whose sum constitutes the <a href="https://en.wikipedia.org/wiki/Dependent_and_independent_variables">manipulated variable</a> (MV). The proportional, integral, and derivative terms are summed to calculate the output of the <a href="https://en.wikipedia.org/wiki/PID_controller">PID controller</a>.</p>
				    				</Thumbnail>
				    			</Col>

				    			<Col xs={12} md={6}>
				    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_02}>
				    				<h3>C# and GDI+</h3>
						         <p className="text-justify" style={fontSize}>Each piece of equipment is controllable within the simulator with <a href="https://en.wikipedia.org/wiki/Control_panel_(engineering)">face-plates</a>, graphs, and advanced controls including automation and manual control. All graphics are built around the <a href="https://en.wikipedia.org/wiki/Graphics_Device_Interface">GDI+</a> classic windows drawing library. During the architecture phase, I had designed my own graphics library around <a href="https://en.wikipedia.org/wiki/Graphics_Device_Interface">GDI+</a> for building controls, connectors, graphs, etc. Each image is a stand-alone C# user-control with self-sustaining encapsulated logic. This Ball Mill simulator controls the level of a slurry tank.</p>
				    				</Thumbnail>
				    			</Col>
				    		</Row>
				    	</Grid>
	          </div>

	          <center>
	          	<Button href={zip_01}>Column-Cell Flotation</Button>
	          	<Button href={zip_02}>Ball-Mill Simulator</Button>
	          </center>
				</Jumbotron>

				<Grid className="blockpadding">
	    		<div className="well">
		    		<Row>
		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_03}>
			    			</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_04}>
			    			</Thumbnail>
		    			</Col>
		    		</Row>

		    		<Row>
		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_05}>
			    			</Thumbnail>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<Thumbnail className="img-responsive center-block img-fluid" src={imgHeader_06}>
			    			</Thumbnail>
		    			</Col>
		    		</Row>
	    		</div>
	    	</Grid>

    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default Simulators;



// WEBPACK FOOTER //
// ./src/cba/appspec/body/Simulators.js